import Schema from 'AppReact/schema';
import { filterDropdownOption } from "types";

export default {
  isOpen: Schema('boolean', 'primitive', { defaultValue: false }),
  isReadonly: Schema('boolean', 'primitive', { defaultValue: false }),
  label: Schema("string", "primitive", { defaultValue: '' }),
  width: Schema("string", "primitive-nullable", { defaultValue: null }),
  placeholder: Schema("string", "primitive-nullable", { defaultValue: '' }),
  containerRef: Schema({}, 'object', { defaultValue: null }),
  occurrenceValues: Schema('string', 'array', { defaultValue: [] }),
  frequency: Schema('string', 'primitive', { defaultValue: '' }),
  dates: Schema('integer', 'array', { defaultValue: Array.from({ length: 31 }, (_, index) => index + 1) }),
  selectedMonthIndex: Schema('integer', 'primitive', { defaultValue: 1 })
}